import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { TrainingService } from 'app/_services/training.service';

@Component({
  selector: 'edit-video-section-modal',
  templateUrl: './edit-video-section-modal.component.html',
})
export class EditVideoSectionModalComponent implements OnInit {

  addVideoSectionForm: FormGroup;
  video: any[];

  constructor(private activeModal: NgbActiveModal,
    public fb: FormBuilder,
    public trainingService: TrainingService) {
  }

  ngOnInit() {
    this.createVideoSectionForm();
  }

  // Form
  public createVideoSectionForm () {
    this.addVideoSectionForm = this.fb.group({
      video: new FormControl ('', Validators.required),
    });
  }

  public submitVideoSection() {
    this.activeModal.close(({
      video: this.addVideoSectionForm.value.video
    }));
  }

  // Modal
  public closeModal() {
    this.activeModal.dismiss('close');
  }
}
